<template>
  <RouterLink
    :to="item.href"
    class="flex items-center px-3 py-2 text-sm font-medium rounded transition-colors group"
    :class="[
      isActive
        ? 'bg-sidebar-surface text-primary-400'
        : 'text-sidebar-text hover:bg-sidebar-surface hover:text-white',
      isCollapsed ? 'justify-center' : 'space-x-3'
    ]"
  >
    <span class="text-xl flex-shrink-0">{{ item.icon }}</span>
    <span v-if="!isCollapsed">{{ item.name }}</span>

    <!-- Tooltip for collapsed state -->
    <div
      v-if="isCollapsed"
      class="absolute left-20 px-2 py-1 bg-neutral-900 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50"
    >
      {{ item.name }}
    </div>
  </RouterLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { RouterLink, useRoute } from 'vue-router'

interface NavItemProps {
  item: {
    name: string
    href: string
    icon: string
  }
  isCollapsed: boolean
}

const props = defineProps<NavItemProps>()
const route = useRoute()

const isActive = computed(() => route.path === props.item.href)
</script>
